import { useState } from 'react'
import {
  Show,
  Create,
  SimpleForm,
  FormDataConsumer,
  required,
  SelectInput,
  ReferenceInput,
  TextInput,
  useDataProvider,
} from 'react-admin'
import {
  Dialog,
  DialogTitle,
  Button,
  Typography,
  Toolbar,
} from '@material-ui/core'
import { DynamicInputComponentSelf } from '../tickets_common'
import CheckIcon from '@mui/icons-material/Check'
import FileWithContext from '../models/file_with_context'
import UpsertFileButton from '../components/file_upload'
import Relation from '../models/relation'
import BindFile from '../exceptions/file_with_context/bind_file'

export const ExtCoproTicketCreateDialog = (props) => {
  const [process, setProcess] = useState(undefined)
  const [processid, setProcessid] = useState(-1)
  const [files, setFiles] = useState([])
  const dataProvider = useDataProvider()

  //NOTE: we need ticket_fields info for dataprovider, so that it can convert image fields to base64
  const init_values = {
    ticket_fields: process ? process.ticket_fields : [],
    copro_id: props.copro_id,
    coproprietaire_id: props.coproprietaire_id,
  }

  //NOTE: We use a Show component inside the FormDataConsumer to fetch the process object
  //and the fields key.
  //By luck, input fields inside the Show still have their values taken into
  //account by the outer Create component

  const onFailure = (error) => {
    alert(`${error.message}`)
  }
  const onSuccess = (dataSucces) => {
    const { id } = dataSucces
    const relation = new Relation({
      linkable_type: 'tickets_drafts',
      linkable_id: id,
      copro_id: props.copro_internal_id,
    })
    if (files && files.length > 0) {
      dataProvider
        .updateMany('ext_file_with_context', {
          ids: files.map((f) => f.id),
          data: relation.toJSON(),
        })
        .then(() => {
          alert(
            `Merci ! Votre demande a été enregistrée sous le numéro : ${dataSucces.id}. Elle va être confirmée par notre équipe Support (c'est important, notamment pour ne pas lancer plusieurs interventions pour un même incident).`
          )
          props.setShow(false)
        })
        .catch((e) => {
          throw new BindFile('tickets', id, files.map((f) => f.id).join(', '))
        })
    } else {
      alert(
        `Merci ! Votre demande a été enregistrée sous le numéro : ${dataSucces.id}. Elle va être confirmée par notre équipe Support (c'est important, notamment pour ne pas lancer plusieurs interventions pour un même incident).`
      )
      props.setShow(false)
    }
  }

  return (
    <Dialog
      open={props.show}
      onClose={() => {
        props.setShow(false)
      }}
      maxWidth="sm"
      fullWidth={true}
    >
      <DialogTitle>Demander une intervention</DialogTitle>
      <Create
        {...props}
        onFailure={onFailure}
        mutationOptions={{ onSuccess }}
        resource="ext_tickets_self"
        basePath="/"
        transform={(data) => {
          return { ...data, file_with_context: files }
        }}
      >
        <SimpleForm
          variant="standard"
          defaultValues={init_values}
          toolbar={<FormToolbar />}
        >
          <Typography variant="subtitle1" fullWidth gutterBottom>
            Vous avez la possibilité de demander une intervention par vous-même
            ! Pour cela il vous suffit de remplir le formulaire ci-dessous. 🚀
          </Typography>
          <ReferenceInput
            label="Type"
            source="process_id"
            reference="ext_process"
            validate={[required()]}
          >
            <SelectInput optionText="name" />
          </ReferenceInput>
          <TextInput
            fullWidth
            source="libelle"
            label="Titre (en quelques mots)"
          />
          <FormDataConsumer>
            {({ formData, ...rest }) => {
              if (!formData.process_id) return null
              setProcessid(formData.process_id)
              //NOTE: I dunno why but here style information works on Show component and not on SimpleShowLayout
              //while on Create component it doesn't and must be put under SimpleForm component
              return (
                <>
                  <Show
                    id={formData.process_id}
                    resource="ext_process"
                    basePath="/"
                    title=" "
                    component="div"
                    style={{
                      width: '100%',
                    }}
                  >
                    <DynamicInputComponentSelf
                      showTitle={false}
                      formData={formData}
                      variant="outlined"
                      {...props}
                    />
                  </Show>
                  <Typography
                    variant="subtitle1"
                    fullWidth
                    gutterBottom
                    style={{ color: '#143A5F' }}
                  >
                    Documents divers
                  </Typography>
                  <UpsertFileButton
                    // enable_external={true}
                    expectProvider={false}
                    fromPath="ext_coproprietaires"
                    basePath="/"
                    resource="ext_file_with_context"
                    documentType={FileWithContext.DOCUMENT_TYPE.INTERVENTION}
                    issuedBy={FileWithContext.ISSUED_BY.HELLO_APP}
                    linkable_type="tickets_draft"
                    copro_id={props.copro_id}
                    linkable_id={null}
                    upload_by={formData?.coproprietaire_id}
                    upload_by_type="copros"
                    validCategories={[FileWithContext.CATEGORY.TECHNICAL]}
                    validTypes={[
                      FileWithContext.TYPE.INTERVENTION_REPORT,
                      FileWithContext.TYPE.ANALYSIS_OR_EXPERT_REPORT,
                      FileWithContext.TYPE.INTERVENTION_PHOTO,
                      {
                        [FileWithContext.TYPE.CONTRACT]:
                          FileWithContext.TYPE.OTHERS,
                      },
                    ]}
                    saveResult={(result) => {
                      if (
                        result.accepted_files &&
                        result.accepted_files.length > 0
                      ) {
                        setFiles(result.accepted_files)
                      }
                    }}
                  />
                </>
              )
            }}
          </FormDataConsumer>
        </SimpleForm>
      </Create>
    </Dialog>
  )
}

const FormToolbar = (props) => {
  return (
    <Toolbar>
      <Button
        color="primary"
        variant="contained"
        disableElevation
        startIcon={<CheckIcon />}
        type="submit"
      >
        Enregistrer
      </Button>
    </Toolbar>
  )
}
